import { Box } from '@factorialco/deprecated-design-system'
import { AvailableModules, Features } from 'generated/featureDefinitions'

import i18n from 'modules/core/lib/i18n'

import { REQUEST_SOURCE } from '../../consts/requestSource'
import { UpsellButton } from '../UpsellingButton'

interface UpsellProjectsButtonProps {
  requestComponent?: string
  featureRequested?: Features
  buttonTexts?: {
    requested: string
    unlock: string
  }
  extraButtonProps?: {
    requestedProps: Record<string, unknown>
    unlockProps: Record<string, unknown>
  }
}

export const UpsellProjectsButton = ({
  requestComponent,
  featureRequested = Features.projects_core,
  buttonTexts = {
    requested: i18n.t('finance.financial_workspace.payroll.landing.buttons.requested'),
    unlock: i18n.t('finance.financial_workspace.employee_costs.upsells.projects.unlock_button'),
  },
}: UpsellProjectsButtonProps) => {
  return (
    <Box data-testid="projects-upsell-button">
      <UpsellButton
        moduleRequested={AvailableModules.projects}
        requestSource={`${REQUEST_SOURCE} - ${requestComponent}`}
        featureRequested={featureRequested}
        buttonTexts={buttonTexts}
      />
    </Box>
  )
}
